// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

:root {
  /*
   * Typography
   * ======================================================================== */

  /*
   * Layout
   * ======================================================================== */

  /*
   * Media queries breakpoints
   * ======================================================================== */  /* Extra small screen / phone */  /* Small screen / tablet */  /* Medium screen / desktop */ /* Large screen / wide desktop */
}

.D2D0w {
  margin: 0 auto;
  max-width: 1000px;
  text-align: center;
}

.BYlql {
  text-align: center;
  margin: 15px 10% 0 10%;
}

.BYlql p {
  color: #1a72b5;
  font-size: 1.1em;
}

.NZe4C {
  color:#fff;
  height:45px;
  line-height:42px;
  text-align:center;
  font-size:14px;
  display:block;
  width: 200px;
  margin:10px auto;
  padding:0 20px 0 20px;
  background-color:#4a89dc;
  border:solid 2px #4a89dc;
  border-radius:4px;
  font-weight:900!important;
  text-transform:capitalize;
}

.EmnOj {
  width: 80vw;
  height: 33vw;
  margin-left: auto;
  margin-right: auto;
}

.EmnOj > .ooJ7r {
  height: 100%;
  background-position: center;
  background-size: cover;
}

@media (min-width: 700px) {
  .EmnOj {
    display: inline-block;
    width: 33.3%;
    height: 160px;
  }
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `D2D0w`,
	"intro": `BYlql`,
	"subscribeBtn": `NZe4C`,
	"publicationContainer": `EmnOj`,
	"publicationImg": `ooJ7r`
};
module.exports = ___CSS_LOADER_EXPORT___;
